import Modal from "react-bootstrap/Modal";
import { THEME_COLOR } from "../../config/club";
import BulkAddSection from "../BulkAddSection";
import PlayersListSection from "../PlayersListSection";

export default function PlayersModal({
    show,
    onClose,
    setShowScan,

    /* players-related props */
    sessionId,
    searchTerm,
    setSearchTerm,
    players,
    filteredPlayers,
    sortBy,
    setSortBy,
    sortDirection,
    setSortDirection,
    playerLevels,
    gamesPlayed,
    playingNames,
    queuedMatchesNames,
    queue,
    playerStatusById,
    setQueue,
    setPlayers,
    matchHistory,
    getPlayerLevelMatchStats,
    updatePlayerLevel,
    levelColor,
    ToastShow,
    addPlayers2,
    colsCount
}) {
    const themeAlpha = (opacity) => `${THEME_COLOR}${opacity}`;
    return (
        <Modal
            show={show}
            onHide={onClose}
            size="xl"
            fullscreen="md-down"
            centered
            scrollable
            contentClassName="border-0 shadow-lg rounded-5"
        >
            {/* HEADER */}
            <Modal.Header closeButton className="border-0 px-4 pt-4">
                <Modal.Title
                    className="fw-bold d-flex align-items-center"
                    style={{ color: THEME_COLOR }}
                >
                    <div
                        className="rounded-3 d-flex align-items-center justify-content-center me-3"
                        style={{
                            width: 40,
                            height: 40,
                            backgroundColor: themeAlpha("10"),
                        }}
                    >
                        <i className="bi bi-people-fill"></i>
                    </div>
                    Players
                </Modal.Title>
            </Modal.Header>

            {/* BODY */}
            <Modal.Body className="px-0 pb-4">
                {/* Top Accent Bar */}


                <div className="p-4">
                    {/* <div className="d-flex align-items-center justify-content-between mb-3">
            <button
              className="btn btn-primary rounded-pill"
              onClick={() => setShowScan(true)}
            >
              <i className="bi bi-qr-code-scan me-2" />
              Scan Player
            </button>
          </div> */}

                    <BulkAddSection
                        addPlayers={addPlayers2}
                        existingPlayers={players}
                        THEME_COLOR={THEME_COLOR}
                        levelColor={levelColor}
                    />

                    <PlayersListSection
                        {...{
                            sessionId,
                            searchTerm,
                            setSearchTerm,
                            players,
                            filteredPlayers,
                            sortBy,
                            setSortBy,
                            sortDirection,
                            setSortDirection,
                            playerLevels,
                            gamesPlayed,
                            playingNames,
                            queuedMatchesNames,
                            queue,
                            playerStatusById,
                            setQueue,
                            setPlayers,
                            matchHistory,
                            getPlayerLevelMatchStats,
                            updatePlayerLevel,
                            levelColor,
                            ToastShow,
                            colsCount
                        }}
                    />
                </div>
            </Modal.Body>

            {/* STYLE INJECTION (matches SettingsModal vibe) */}
            <style>{`
        .modal-content {
          border-radius: 28px !important;
        }
        .btn-close:focus {
          box-shadow: none;
        }
      `}</style>
        </Modal>
    );
}
